var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConverticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96235 18.248C6.85762 18.7303 6.37958 19.0409 5.91069 18.8867C4.04621 18.2735 2.43801 17.0367 1.36654 15.3709C0.13313 13.4533 -0.288001 11.1243 0.195792 8.89615C0.679586 6.66805 2.02868 4.72339 3.94627 3.48997C5.86387 2.25656 8.19291 1.83543 10.421 2.31923L10.0417 4.06599C8.2769 3.68279 6.43212 4.01636 4.91324 4.99332C3.39435 5.97028 2.32576 7.5106 1.94256 9.27543C1.55936 11.0403 1.89293 12.885 2.86989 14.4039C3.68472 15.6708 4.89146 16.6243 6.29349 17.1283C6.75799 17.2952 7.06709 17.7656 6.96235 18.248Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0546 2.48169C11.5041 2.74121 11.5041 3.39002 11.0546 3.64955L7.26192 5.83927C7.03717 5.96903 6.75623 5.80683 6.75623 5.54731L6.75623 0.583928C6.75623 0.324405 7.03717 0.162202 7.26192 0.291964L11.0546 2.48169Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6185 3.09618C12.7232 2.61382 13.2012 2.30323 13.6701 2.45744C15.5346 3.07066 17.1428 4.30746 18.2143 5.97328C19.4477 7.89088 19.8688 10.2199 19.385 12.448C18.9012 14.6761 17.5521 16.6208 15.6345 17.8542C13.7169 19.0876 11.3879 19.5087 9.1598 19.0249L9.53908 17.2782C11.3039 17.6614 13.1487 17.3278 14.6676 16.3508C16.1865 15.3739 17.255 13.8336 17.6383 12.0687C18.0215 10.3039 17.6879 8.45913 16.7109 6.94024C15.8961 5.6734 14.6894 4.71982 13.2873 4.21589C12.8228 4.04893 12.5137 3.57854 12.6185 3.09618Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52617 18.8625C8.07666 18.6029 8.07666 17.9541 8.52617 17.6946L12.3189 15.5049C12.5436 15.3751 12.8246 15.5373 12.8246 15.7969V20.7602C12.8246 21.0198 12.5436 21.182 12.3189 21.0522L8.52617 18.8625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConverticon);
export default __webpack_public_path__ + "static/media/convert.icon.b7ebe2b211103cbec9c6cf709daf6a9b.svg";
export { ForwardRef as ReactComponent };